import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import SeoRoutesList from 'components/SeoRoutesList';

import { makeAfter, withData } from 'lib';
import { SeoRouteListPageQuery } from '__generated__/SeoRouteListPageQuery.graphql';

const query = graphql`
  query SeoRouteListPageQuery($first: Int!) {
    ...SeoRoutesList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SeoRouteListPageQuery>;
};

const SeoRouteListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SeoRouteListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={[{ name: 'SEO' }]}>
      <Pagination>
        <Search>
          <SeoRoutesList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SeoRouteListPageQuery>({
  query,
  reloadOnRender: false,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(SeoRouteListPage);
